

export default class KeyValueItem {
	constructor(key = null, value = null) {
		this.key = key
		this.value = value
	}
}